import { render, staticRenderFns } from "./CreateThirdPartyCosts.vue?vue&type=template&id=0bb2752b&"
import script from "./CreateThirdPartyCosts.vue?vue&type=script&lang=js&"
export * from "./CreateThirdPartyCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports